import { redirect } from 'react-router';

import { apiIsomorphicFetchUserEnvironment } from 'api/userEnvironment/apiFetchUserEnvironment';
import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { SIGN_UP_TO_POST_URL_FOR_LOCALE } from 'routing/route-constants';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';
import type { HorizonLoaderFunctionArgs } from 'routing/types/HorizonLoaderFunctionArgs';

import { UserDashboardPostAListingPage } from './UserDashboardPostAListingPage';

export const handle = {
  variant: 'base',
} satisfies LayoutHandleProps;

// Note: this file is not used by hypernova because it uses
// RequireAuthentication with `loginPathname` pointing to a CMS page,
// which causes an infinite loop
export async function loader({
  request,
  context,
}: HorizonLoaderFunctionArgs<void>) {
  const { user } = await apiIsomorphicFetchUserEnvironment({
    request,
    context,
  })();

  if (!user) return redirect(SIGN_UP_TO_POST_URL_FOR_LOCALE[context.locale]);
}

export default function UserDashboardPostAListingHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <UserDashboardPostAListingPage />;
}
